"use client"

import Link from "next/link"
import { ReactNode } from "react"
import { cn } from "@/lib/utils"
import { FadeInWhenVisible } from "@/components/animations"

type HomeSectionProps = {
  title: string
  subtitle?: string
  mobileTitle?: string
  titleColor?: string
  viewAllLink?: string
  children: ReactNode
  className?: string
  backgroundImage?: string
  overlayColor?: string
  fullWidth?: boolean
  centerTitle?: boolean
}

export const HomeSection = ({
  title,
  subtitle,
  mobileTitle,
  titleColor,
  viewAllLink,
  children,
  className = "",
  backgroundImage,
  overlayColor,
  fullWidth = false,
  centerTitle = false,
}: HomeSectionProps) => {
  return (
    <section
      className={cn(
        "pt-[75px] pb-[84px]",
        backgroundImage && "relative",
        className
      )}
      style={backgroundImage ? { backgroundImage: `url(${backgroundImage})`, backgroundRepeat: 'repeat', backgroundSize: 'cover' } : undefined}
    >
      {overlayColor && <div className={`absolute inset-0 ${overlayColor} z-0`}></div>}

      <div className={cn("container", overlayColor ? 'relative z-10' : '')}>
        <FadeInWhenVisible direction="down" duration={0.7}>
          <div className={cn("text-dark02 flex flex-wrap items-center", titleColor, centerTitle && "justify-center")}>
            <h2 className={cn("text-3xl sm:text-5xl font-bold", centerTitle ? "text-center" : "sm:text-left", mobileTitle ? 'hidden lg:block' : '')}>
              {title}
            </h2>
            {mobileTitle && (
              <h2 className={cn("lg:hidden text-3xl sm:text-5xl font-bold", centerTitle ? "text-center" : "text-center sm:text-left")}>
                {mobileTitle}
              </h2>
            )}
            {viewAllLink && (
              <>
                <div className="flex-1"></div>
                <Link
                  className={cn("text-base sm:text-xl text-center font-bold bg-matco",
                    "hover:bg-matco/80 transition-all duration-300 text-dark02",
                    "hover:shadow-[0px_0px_4px_0px_#00000040] inline-flex items-center justify-center",
                    "w-24 h-9 sm:w-32 sm:h-11 rounded-lg")}
                  href={viewAllLink}
                >
                  VER MÁS
                </Link>
              </>
            )}
            {subtitle && (
              <p className={cn("w-full text-lg text-gray-800 mt-4", centerTitle ? "text-center" : "sm:text-left")}>
                {subtitle}
              </p>
            )}
          </div>
        </FadeInWhenVisible>

        <div className={cn("mt-[63px]", fullWidth ? "-mx-4" : "")}>
          {children}
        </div>
      </div>
    </section>
  )
} 